import { default as display } from './display.svelte'
import { HiloBet} from './HiloBet'

export { HiloBet }
export default{ display }
